import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { therapistDisciplineList } from 'src/redux/actions/constant';
import TherapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_THERAPIST_DISCIPLINE_LIST_FAILURE,
  GET_THERAPIST_DISCIPLINE_LIST_REQUEST,
  GET_THERAPIST_DISCIPLINE_LIST_SUCCESS,
} = therapistDisciplineList;

function* getAllDisciplineTherapists(action: any): SagaReturnType<any> {
  try {
    const response = yield call(TherapistSchedulingServices.getAllTherapistList, action.payload);
    if (response?.status === 200) {
      yield put({
        type: GET_THERAPIST_DISCIPLINE_LIST_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPIST_DISCIPLINE_LIST_FAILURE, payload: error });
  }
}

function* getAllDisciplineTherapistsSaga() {
  yield takeEvery(GET_THERAPIST_DISCIPLINE_LIST_REQUEST, getAllDisciplineTherapists);
}

export default getAllDisciplineTherapistsSaga;
